export const PageDataState = {
    Searchs: {
        manpower_establishments_id: {
            type: 'select',
            id: 'manpower_establishments_id',
            label: 'รหัส',
            value: '',
            placeholder: 'รหัส',
        },
        education_level_id: {
            type: 'select',
            id: 'education_level_id',
            label: 'ระดับการศึกษา',
            value: '',
            placeholder: 'ระดับการศึกษา',
        },
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: false
            },
            error: { status: null, msg: '' }
        },
        manpower_establishments_id: {
            type: 'select',
            id: 'manpower_establishments_id',
            label: 'รหัสตำแหน่ง',
            value: '',
            validator: {
                type: 'text',
                required: true
            },
            error: { status: null, msg: '' }
        },        
        education_level_id: {
            type: 'select',
            id: 'education_level_id',
            label: 'ระดับการศึกษา',
            value: '',
            validator: {
                type: 'text',
                required: true
            },
            error: { status: null, msg: '' }
        },       
    },
    InputGroup: {}
}